import { render, staticRenderFns } from "./AngleTrim.vue?vue&type=template&id=42fd31f9&"
import script from "./AngleTrim.vue?vue&type=script&lang=js&"
export * from "./AngleTrim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/myraj/m247/git/landing-pages/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42fd31f9')) {
      api.createRecord('42fd31f9', component.options)
    } else {
      api.reload('42fd31f9', component.options)
    }
    module.hot.accept("./AngleTrim.vue?vue&type=template&id=42fd31f9&", function () {
      api.rerender('42fd31f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/AngleTrim.vue"
export default component.exports